module.exports = __webpack_public_path__ + "img/no-pic.b6681619.png";